import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import type {
  Assignee,
  InstitutionMember,
} from '@backrs_ui/grow-ui/src/redux/coachingDashboard/coachingDashboard.types';

export const useAgentContext = (member: Assignee | InstitutionMember | undefined) => {
  useRegisterAgentContext(
    member
      ? {
          kind: 'section',
          title: 'Blueprint',
          description:
            'The Blueprint on screen belongs to the student this page names, not to the signed-in coach. The Blueprint entries in this context -- Summary of Life Aspirations, Minimum Career Track, Educational Investments, Career Paths, Ownership -- all describe that student.',
        }
      : null,
  );
};
